import {i18n} from "../../../Utils/i18n/i18n";
import './IsReadyForDownloadCell.scss';

export const IsReadyForDownloadCell = ({value}) => {
    return <div className="IsReadyForDownloadCell">
        {value ?  i18n.translate('FilesManagementPage.fileManagementTable.ready') : i18n.translate('FilesManagementPage.fileManagementTable.inProgress')}
    </div>
}